export const TOOLS_LIST = [
    {   
      id: 'calculator',
      title: 'Calcular Materiales',
      iconUrl: 'assets/icons/calcular-materiales.png',
      isNew: true,
      route: '/calculator'
    },
    {
      id: 'quote',
      title: '¡Arma tu Lista de Materiales!',
      iconUrl: 'assets/icons/cotizar-materiales.png',
      route: '/quote-step-1'
    },
    {
      id: 'unicon',
      title: 'Pedir Productos UNICON',
      iconUrl: 'assets/icons/productos-unicon.png',
      route: '/unicon-chat'
    },
    {
      id: 'training',
      title: 'Capacitarme',
      iconUrl: 'assets/icons/capacitarme.png',
      route: '/inicio'
    },
    {
      id: 'contract',
      title: 'Crear Contrato',
      iconUrl: 'assets/icons/crear-contrato.png',
      route: '/contract/new'
    },
    {
      id: 'work',
      title: 'Buscar Trabajo',
      iconUrl: 'assets/icons/buscar-trabajo.png',
      isComingSoon: true
    },
  ];